<!-- <mat-form-field class="w-100" [hideRequiredMarker]="true"> -->
  <mat-checkbox [formControl]="control" [class.disabled]="control.disabled">
    {{ label }}
  </mat-checkbox>
<!-- </mat-form-field> -->